import React from "react";
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Modal,
  Image,
  Button
} from '@lockerpm/design';

import {
  ArrowRightOutlined
} from "@ant-design/icons";

import images from "../../assets/images";

import global from "../../config/global";
import storeActions from "../../store/actions";
import onboardingServices from "../../services/onboarding";
import common from "../../utils/common";

const GetExtensionModal = () => {
  const { t } = useTranslation();
  const { ExtensionImg } = images;

  const getExtensionVisible = useSelector((state) => state.onboarding.getExtensionVisible)
  const onboardingProcess = useSelector((state) => state.onboarding.onboardingProcess)
  const tutorialProcess = useSelector((state) => state.onboarding.tutorialProcess)

  const onClose = () => {
    global.store.dispatch(storeActions.updateGetExtensionVisible(false));
  }

  const handleClick = async () => {
    common.openNewTab(global.urls.CHROME_EXTENSION_URL);
    let payload = null;
    if (!tutorialProcess.includes('view_autofill')) {
      payload = {
        tutorial_process: [...tutorialProcess, 'view_autofill']
      }
    }
    if (!onboardingProcess.tutorial) {
      payload = {
        ...payload,
        tutorial: true
      }
    }
    if (payload) {
      await onboardingServices.update_onboarding(payload);
    }
    onClose();
  }
  
  return (
    <Modal
      open={getExtensionVisible}
      onCancel={() => {}}
      width={500}
      footer={false}
      closeIcon={<></>}
    >
      <div>
        <h1 className="font-medium text-[28px] text-black mb-6">
          {t('welcome_tour.steps.view_autofill.modal.title')}
        </h1>
        <Image
          src={ExtensionImg}
          preview={false}
        />
        <div className="my-4">
          <p className="mb-2">
            {t('welcome.desc')}
          </p>
          <ul style={{ listStyleType: 'circle' }}>
            {
              [1, 2, 3].map((item) => <li key={item}>
                {t(`welcome_tour.steps.view_autofill.modal.note${item}`)}
              </li>)
            }
          </ul>
        </div>
        <div className="flex items-center justify-between mt-6">
          <Button
            type="primary"
            size="large"
            icon={<ArrowRightOutlined />}
            onClick={() => handleClick()}
          >
            {t(`welcome_tour.steps.view_autofill.btn`)}
          </Button>
          <Button
            size="large"
            type="text" onClick={() => onClose()}>
            {t('button.close')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default GetExtensionModal;